import { useDispatch } from "react-redux";
import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import commonActions from "../../Actions/commonActions";
import {FormInput} from "../FormComponents/Input/Input";
import {Button, ButtonOption} from "../Fundamentals/Button";
import {customerUtils as customerHelpers} from "../../Utils";
import activitylogActions from "../../Actions/InternalCustomerAdmin/activityLogActions";
import {Dropdown} from "../FormComponents/Dropdown";
import {DateInterval} from "../FormComponents/DateInterval";
export const EventLogForm = ({ form, customer, subscriptions, collaborations }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const data = form?.data ?? {};

    const filteredCollaborations = collaborations ? collaborations.filter((item, index, self) =>
        item.clientId &&
        index === self.findIndex((t) => t.clientId === item.clientId)
    ) : [];

    const onFieldChange = (value, field) => {
        if (!form?.id) return;
        dispatch(commonActions.changeMultiFormField(form.id, field, value));
    }
    
    useEffect(() => {
        if (data.clientId) {
            onFieldChange(null, "subscriptionId");
        }
    }, [data.clientId])

    const mappedSubscriptions = subscriptions?.map(sub => ({
        ...sub,
        packageName: sub.package?.name || 'Unknown Package'
    })) || [];

    const onSubmit = () => {
        dispatch(activitylogActions.searchLogs(data));
    }

    return <div className="d-grid grid-cols-3">
        <fieldset className="d-grid gap-16">
            <FormInput label={t("common.customerid")} required={true} readOnly={!!customer} property={"value"} value={data.customerId} onChange={(value) => onFieldChange(value, "customerId")}/>

            {!customer ? <>
                <FormInput label={t("common.clientid")} value={data.clientId} onChange={(value) => onFieldChange(value, "clientId")}/>
                <FormInput label={t("common.subscriptionid")} disabled={data.clientId} value={data.subscriptionId} onChange={(value) => onFieldChange(value, "subscriptionId")}/>
            </> : <>
                {customerHelpers.isAoCustomer(customer?.vossCustomer) && <Dropdown label={t("loggingContainer.aoClient")} valueProperty={"clientId"} property={"name"} value={data.clientId} options={filteredCollaborations}
                                                                                   onChange={(value) => onFieldChange(value, "clientId")}/>}
                <Dropdown label={t("subscriptions.subscription")}  disabled={!customer || data.clientId} options={mappedSubscriptions} value={data.subscriptionId} valueProperty={'id'} property={"packageName"}
                          onChange={(value) => onFieldChange(value, 'subscriptionId')}/>
            </>}
            <div>
                <label>{t("activitylogform.dateinterval")}</label>
                <DateInterval 
                    onChangeFromDate={(value) => onFieldChange(value, 'fromDate')}
                    onChangeToDate={(value) => onFieldChange(value, 'toDate')}
                    fromDateValue={data.fromDate}
                    toDateValue={data.toDate}
                />
            </div>
            <div className={"d-grid justify-content-start"}>
                <Button option={ButtonOption.PRIMARY} disabled={!data.customerId} onClick={onSubmit}>{t("common.search")}</Button>
            </div>
        </fieldset>
        <fieldset className="d-grid gap-16 ml-24 mt-24">
            {t("loggingContainer.eventLogDescription")}
        </fieldset>
    </div>
}

